<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="title"
      :modal="true"
      :width="'500px'"
      @open="setSendInfo"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="pop-container">
      <div class="pop-conts">
        <div class="pwindow">
          <ul class="filter_list">
            <li>
              <label>운송장 번호<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <input
                      v-model.trim="blNo"
                      @input="blNo=EtnersCommonUtil.cutByteLength(blNo, 100)"
                      placeholder="-"
                  >
                </li>
              </ul>
            </li>
            <li>
              <label>금액<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <input
                      type="number"
                      v-model="regCost"
                      @input="regCost=EtnersCommonUtil.cutByteLength(regCost, 50)"
                      placeholder="-"
                  >
                </li>
              </ul>
            </li>
            <li>
              <label>이메일</label>
              <ul class="w70">
                <li>
                  <kendo-maskedtextbox
                      class="w100"
                      v-model="sendMailAddr"
                      :placeholder="'이메일을 입력하세요.'"
                  >
                  </kendo-maskedtextbox>
                  안내 메일발송을 위해 이메일 주소를 입력해주세요
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="button_area w60 mgt30">
          <ul>
            <li class="w25">
              <button class="large_btn" @click="onClickCloseWindow">취소</button>
            </li>
            <li class="w25">
              <button class="large_btn orange ml10" @click="onClickSaveData">저장</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </kendo-window>
</template>

<script>
import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";

export default {
  name: "RegiRequiredInfoWindow",
  props: {
    title: {
      type: String,
      required: false,
      default: function () {
        return "title"
      }
    },
    sendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
  methods: {
    setSendInfo () {
      const vm = this

      vm.blNo = vm.sendInfo.blNo
      vm.regCost = vm.sendInfo.regCost
      vm.sendMailAddr = vm.sendInfo.sendMailAddr
    },

    onClickSaveData () {
      const vm = this

      // 유효성 체크
      if (EtnersCommonUtil.isEmpty(vm.blNo)) {
        kendo.alert('운송장 번호를 입력해주세요.')
        return
      } else if(!EtnersCommonUtil.isBlNo(vm.blNo)) {
        kendo.alert('운송장 번호는 영어와 숫자만 입력해주세요.')
        return
      }
      if (EtnersCommonUtil.isEmpty(vm.regCost)) {
        kendo.alert('신고 금액을 입력해주세요.')
        return
      } else if(!EtnersCommonUtil.isPositiveInteger(vm.regCost)){
        kendo.alert('신고 금액은 1이상의 숫자를 입력해주세요')
        vm.errorTarget = 'regCost'
        return
      }

      this.$emit('getInfoForRegi', vm.blNo, vm.regCost, vm.sendMailAddr)
      vm.onClickCloseWindow()
    },
    onClickCloseWindow () {
      this.$refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      blNo: null,
      regCost: null,
      sendMailAddr: null,
    }
  }
}
</script>

<style scoped>

</style>